// THIS FILE IS AUTO GENERATED
var GenIcon = require('../lib').GenIcon
module.exports.IconArrowThinRight = function IconArrowThinRight (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","transform":"scale(.7)"},"child":[{"tag":"title","attr":{}},{"tag":"polygon","attr":{"id":"fill-color","points":"6.002 2.30926389e-14 5 0.997 16.002 12 5.002 23 6 23.996 15.596 14.401 15.6008362 14.4069826 18.002 12 15.6008362 9.59301739 15.595 9.599"}}]})(props);
};
